var _rect, _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSearchResultsPlaceholder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 4,
    fill: "#F2F2F2"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M27.0876 13.668C21.8845 13.668 17.6665 17.8859 17.6665 23.089C17.6665 28.2921 21.8845 32.5101 27.0876 32.5101C29.3285 32.5101 31.3878 31.7266 33.0046 30.4204L37.5856 35.0013C37.9761 35.3918 38.6093 35.3918 38.9998 35.0013C39.3904 34.6108 39.3904 33.9776 38.9998 33.587L34.4189 29.0061C35.7252 27.3893 36.5086 25.33 36.5086 23.089C36.5086 17.8859 32.2906 13.668 27.0876 13.668ZM19.6665 23.089C19.6665 18.9905 22.989 15.668 27.0876 15.668C31.1861 15.668 34.5086 18.9905 34.5086 23.089C34.5086 25.1385 33.679 26.9925 32.335 28.3365C30.991 29.6805 29.1372 30.5101 27.0876 30.5101C22.989 30.5101 19.6665 27.1876 19.6665 23.089Z",
    fill: "#999999"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M8 29.668C8 29.1157 8.44772 28.668 9 28.668H15C15.5523 28.668 16 29.1157 16 29.668C16 30.2202 15.5523 30.668 15 30.668H9C8.44772 30.668 8 30.2202 8 29.668Z",
    fill: "#999999"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23.332C8 22.7798 8.44771 22.332 9 22.332H13.6667C14.2189 22.332 14.6667 22.7798 14.6667 23.332C14.6667 23.8843 14.2189 24.332 13.6667 24.332H9C8.44772 24.332 8 23.8843 8 23.332Z",
    fill: "#999999"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 17C8 16.4477 8.44772 16 9 16H15C15.5523 16 16 16.4477 16 17C16 17.5523 15.5523 18 15 18H9C8.44772 18 8 17.5523 8 17Z",
    fill: "#999999"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearchResultsPlaceholder);
export default __webpack_public_path__ + "static/media/search-results-placeholder.6eceb7314094488502230125a5267687.svg";
export { ForwardRef as ReactComponent };